/*
* Copyright (C) Regione Lombardia
*/
export enum UtenteStatusEnum {
    WAITING = 1,
    COMPLETED = 2,
    REJECTED = 3,
}
